import BookingFormWidgetsManager from './BookingFormWidgetsManager';
import shouldIgnoreUrl from './helpers/shouldIgnoreUrl';

const BOOKING_FORM_URL =
    (import.meta.env.VITE_BOOKING_FORM_URL as string) ?? '';

const domainRegex = /\/\[tenantId](.*)\/\[locale]\//;
const matches = BOOKING_FORM_URL.match(domainRegex);
const domain = matches?.[1] ?? '.letsbook.app';

class DeeplinkManager {
    private bookingForms: BookingFormWidgetsManager;

    constructor(bookingForms: BookingFormWidgetsManager) {
        this.bookingForms = bookingForms;

        this.detectIfDeeplinkCalled = this.detectIfDeeplinkCalled.bind(this);

        window.addEventListener('hashchange', this.detectIfDeeplinkCalled);
        this.detectIfDeeplinkCalled();
    }

    destroy() {
        window.removeEventListener('hashchange', this.detectIfDeeplinkCalled);
    }

    private detectIfDeeplinkCalled(): void {
        const params = new URLSearchParams(window.location.hash.substring(1));
        const url = params.get('lb');

        if (!url) {
            return;
        }

        const normalizedUrl = this.normalizeUrl(url);
        if (shouldIgnoreUrl(normalizedUrl, domain)) {
            return;
        }

        this.bookingForms.showUsingUrl(normalizedUrl);
    }

    private normalizeUrl(url: string): string {
        if (url.startsWith('https://')) {
            return url;
        }

        return `https://${url}`;
    }
}

export default DeeplinkManager;
